import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Location } from '@angular/common';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { Subscription } from 'rxjs';
import { AppService } from './services/app/app.service';
import { EventsService } from './services/events/events.service';
import { RxStompService } from './services/websocket/rxstomp.service';
import { Message } from '@stomp/stompjs';
import { RestService } from './services/rest/rest.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ParameterCart } from './models/cart-model';
import { Utils } from './components/utils/Utils';
import { Log } from './core/logging/log';
import { env } from 'process';
import { environment } from 'environments/environment';
import { UiMessageService } from './services/websocket/ui/ui-message-service';
import { ConfigService } from './services/config/config.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private _router: Subscription;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;
    

    constructor(public appService: AppService,
        private restService: RestService,
        private rxStompService: RxStompService,
        private uiMessageService: UiMessageService,
        private eventsService: EventsService,
        private gtmService: GoogleTagManagerService,
        public configService: ConfigService,
        private renderer : Renderer2, 
        private router: Router, 
        private route: ActivatedRoute,
        @Inject(DOCUMENT,) 
        private document: any, 
        private element : ElementRef, 
        public location: Location
        ) {}

        
    ngOnInit() {

        this.route.queryParams.subscribe(params => {
            let update:boolean = false;
            let parameters:ParameterCart = Utils.getParams(this.route.snapshot.queryParamMap);

            //alert('param');
            Log.debug('params', {params});
            if(params!=null && params['tenant_id'] != null){
                let tenantId = params['tenant_id'];
                this.appService.tenantId = tenantId;
            }            

            if(params!=null && params['lang'] != null){
                let lang = AppService.langs.find(f=>f.name == params['lang']);
                AppService.setLang(lang);
            }

            if(params!=null && params['commissionAgentId'] != null){
                parameters.commissionAgentId = params['commissionAgentId'];
                update = true;
            }
            
            if(params != null && params['discountCode'] != null){
                parameters.userData.discountCode = params['discountCode']; 
                update = true;
            }

            if(update){
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: Utils.generateParams(parameters),
                    // queryParamsHandling: 'merge'
                });
            }
        });

        this.appService.setMeta(
            this.appService.getTraduccion('meta.title'), 
            this.appService.getTraduccion('meta.description'), 
            this.appService.getTraduccion('meta.keywords')
        );
        //this.updateFavicon();

        this.router.events.subscribe(event => {
            if(event instanceof NavigationEnd) {
                let host = window.location.host;
                host = host.replace(/\/$/, "");
                host = host.indexOf('www.') && host || host.replace('www.', '');
                let pathname = window.location.pathname;
                pathname = pathname.replace(/\/$/, "");
                pathname = pathname.replace(/\//, "");
                let canonical = 'https://www.' + host + '/' + pathname;
                this.createLink(canonical);

            }
            // NavigationEnd
            // NavigationCancel
            // NavigationError
            // RoutesRecognized
        });
        this.setLangHtml();

        /*
        var navbar : HTMLElement = this.element.nativeElement.children[0].children[0];
        this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (window.outerWidth > 991) {
                window.document.children[0].scrollTop = 0;
            }else{
                window.document.activeElement.scrollTop = 0;
            }
            this.navbar.sidebarClose();
        });
        navbar.classList.remove('navbar-transparent');
        //navbar.classList.remove('fixed-top');       
        
        this.renderer.listen('window', 'scroll', (event) => {
            const number = window.scrollY;
            if (number > 150 || window.pageYOffset > 150) {
                // add logic
                //navbar.classList.remove('navbar-transparent');
            } else {
                // remove logic
                //navbar.classList.add('navbar-transparent');
            }
        });
        var ua = window.navigator.userAgent;
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            var version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        if (version) {
            var body = document.getElementsByTagName('body')[0];
            body.classList.add('ie-background');

        }
        */

        this.getProfile();
 
        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
              if (!this.gtmService.getDataLayer()) {
                return;
              }

              const gtmTag = {
                event: 'page',
                pageName: item.url
              };
              Log.debug("google tagmanager")
              this.gtmService.pushTag(gtmTag);
            }
          });

    }

    ngOnDestroy(): void {
        //this.eventsService.destroy('callFindFreeLocker');
        //this.eventsService.destroy('calculatorStep2');
	}

    createLink(url: string) {
        let canonical:any = this.document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }else{
            let link: HTMLLinkElement = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', url);
            this.document.head.appendChild(link);
        }
    }

    setLangHtml() {
        let canonical:any = this.document.querySelector('html');
        if (canonical !== null) {
            canonical.lang = AppService.langSel.name;
        }
    }

    private updateFavicon(): void {
        const faviconUrl = this.configService.settings?.logo?.imageSmall
            || this.configService.settings?.logo?.imageMedium
            || this.configService.settings?.logo?.imageLarge;

        if (!faviconUrl) {
            return;
        }

        this.upsertLinkTag('app-favicon-32', 'icon', faviconUrl, 'image/png', '32x32');
        this.upsertLinkTag('app-favicon-16', 'icon', faviconUrl, 'image/png', '16x16');
        this.upsertLinkTag('app-apple-touch-icon', 'apple-touch-icon', faviconUrl);
    }

    private upsertLinkTag(
        id: string,
        rel: string,
        href: string,
        type?: string,
        sizes?: string
    ): void {
        let linkElement = this.document.getElementById(id) as HTMLLinkElement | null;

        if (!linkElement) {
            linkElement = this.document.createElement('link');
            linkElement.id = id;
            linkElement.rel = rel;
            this.document.head.appendChild(linkElement);
        }

        linkElement.href = href;

        if (type) {
            linkElement.type = type;
        }

        if (sizes) {
            linkElement.setAttribute('sizes', sizes);
        } else {
            linkElement.removeAttribute('sizes');
        }
    }

    get showTenantAs():boolean {
        return !environment.production;
    }

    showLoginAs():boolean {
        return this.appService.isAdmin() || this.appService.isImpersonating();
    }

    showHeader() {
        return true;
        
        var titlee = this.location.prepareExternalUrl(this.location.path());
        let found = titlee.split('/').find(f=>f=='reserve')!=undefined;
        if(found){
            return true;
        }else{
            return false;
        }
    }

    showFooter() {
        return true;
        return this.router.url.includes('locker-type') 
        || this.router.url.includes('visor');
    }

    getProfile(){
        if(!AppService.isToken()){
            Log.debug('Token not exist');
            return;
        }
        this.restService.getProfile().subscribe(result => {
          Log.debug('getProfile', {result});
          if(result.id !=null && result.id != 0){
            AppService.autenticado = true;
            this.appService.usuario = result;
            if(this.appService.isAdmin()){
                this.iniWebsocket();
            }
            this.eventsService.publish('getProfile', result);
            this.appService.setCurrentUser(result);
          }
        },
          error => {
            Log.error('error', {error});
            Log.error('error', {status: error.status});
            if(error.status == 401){
                AppService.autenticado = false;
                AppService.clearToken();
            }
            //this.router.navigate(["/login"]);
          }
        );
      }

    iniWebsocket(){
        if(!AppService.autenticado){
            return;
        }
        this.rxStompService.activate();
        this.uiMessageService.subscribe();

       // this.rxStompService.watch('/user/queue/getUser').subscribe((message: Message) => {
       //     console.log('/user/queue/getUser', message.body)
       // });
          
        //let message = JSON.stringify( {
        //    "clientSelected": this.appService.clientSelected
        //} );
        //this.rxStompService.publish({ destination: '/server/getUser', body: message });

        let called = false;
        /*this.rxStompService.watch('/user/queue/updated-server').subscribe((message: Message) => {

            this.appService.showDangerToast(message.body, 3000);
            if(!called){
                called = true;
                setTimeout(()=>{
                    this.eventsService.publish("updatedFromServer", message);
                    called = false;
                }, 10000);
            }
        });*/
    }

    onSendMessage() {
        let message = `Message generated at ${new Date()}`;
        message = JSON.stringify( {'place': 'sdfdf'} );
        this.rxStompService.publish({ destination: '/server/website-admin', body: message });
    }

}
